var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"click":_vm.emitInput}}),_c('span',{staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }